import { deleteAssessment } from '@actions/assessments';
import {
    getAssessmentsIsPatching,
    getAssessmentsPatchError,
    getAssessmentsPatchSuccess,
} from '@selectors/assessments';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

const useDeleteAssessment = (assessmentId: number, closeModal: () => void) => {
    const dispatch = useDispatch();

    const isDeleting = useSelector(getAssessmentsIsPatching);
    const deleteSuccess = useSelector(getAssessmentsPatchSuccess);
    const deleteError = useSelector(getAssessmentsPatchError);

    const prevSuccess = usePrevious(deleteSuccess);
    useEffect(() => {
        if (!prevSuccess && deleteSuccess) {
            closeModal();
        }
    }, [prevSuccess, deleteSuccess, closeModal]);

    const submitDelete = () => {
        dispatch(deleteAssessment(assessmentId));
    };

    return { isDeleting, deleteError, submitDelete };
};

export default useDeleteAssessment;
